/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import {
  Box,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import React from "react";

export default function Home() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Box
        bg={boxBg}
        p="30px"
        borderRadius="md"
        shadow="md"
      >
        <Text
          fontSize="3xl"
          color={brandColor}
          fontWeight="700"
          lineHeight="110%"
          mb="20px"
        >
          Welcome to AIVRM
        </Text>
        <Text
          fontSize="xl"
          color="gray.600"
          fontWeight="500"
          lineHeight="150%"
          mb="10px"
        >
          AI-based Vulnerability and Risk Management
        </Text>
        <Text
          fontSize="md"
          color="gray.500"
          fontWeight="400"
          lineHeight="150%"
        >
          Our goal is simple: to help transform cybersecurity teams by prioritizing vulnerability management based on the risk to a business's operations.
          <br /><br />
          By leveraging real business impact rather than simple severity scores, we empower your teams to make informed decisions and protect what matters most.
        </Text>
      </Box>
    </Box>
  );
}
